import {InvoiceSummaryApiDto} from "../../api/model/rest";
import {option, Option} from "ts-option";
import moment = require("moment");

export default class InvoiceSummary {

	constructor(public readonly id: string,
		public readonly customerDisplayName: string,
		public readonly invoiceNo: Option<string>,
		public readonly invoiceDate: moment.Moment,
		public readonly referenceNumber: string,
		public readonly due: number,
		public readonly total: number) {}

	static fromJson(json: InvoiceSummaryApiDto): InvoiceSummary {
		return new InvoiceSummary(json.id, json.customerDisplayName, option(json.invoiceNo), moment(json.invoiceDate),
			json.referenceNumber, json.due, json.total);
	}
}
